"use client";

import Script from "next/script";

// Cloudflare's shared always-pass test sitekey - see
// https://developers.cloudflare.com/turnstile/troubleshooting/testing/.
// Used as a dev fallback so the widget renders (and lib/turnstile.ts's
// matching test secret accepts it) before NEXT_PUBLIC_TURNSTILE_SITE_KEY is
// set for real.
const TEST_SITE_KEY = "1x00000000000000000000AA";

// Shared bot-check widget for the public auth forms (register,
// forgot-password). Implicit render: the Cloudflare script scans the DOM
// for `.cf-turnstile` and injects a hidden `cf-turnstile-response` input
// into the surrounding <form> itself, so no extra wiring is needed here.
export function TurnstileWidget() {
  const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY ?? TEST_SITE_KEY;

  return (
    <>
      <Script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer />
      <div className="cf-turnstile" data-sitekey={siteKey} data-language="pl" />
    </>
  );
}
